"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getMinHeight = exports.getMinWidth = exports.getTextWidth = exports.getVerticalBorderWidth = exports.getHorizontalBorderWidth = void 0;
var tslib_1 = require("tslib");
var elements = tslib_1.__importStar(require("./elements"));
function getNumberValue(value) {
    var number = parseInt(value, 10);
    return isFinite(number) ? number : 0;
}
function getHorizontalBorderWidth(root) {
    var element = elements.getPopoverElement(root);
    var button = elements.getButtonElement(root);
    var size = 0;
    if (element) {
        var elementStyle = window.getComputedStyle(element);
        size += getNumberValue(elementStyle.borderLeftWidth);
        size += getNumberValue(elementStyle.borderRightWidth);
    }
    if (button) {
        var buttonStyle = window.getComputedStyle(button);
        size += getNumberValue(buttonStyle.borderLeftWidth);
        size += getNumberValue(buttonStyle.borderRightWidth);
    }
    return size;
}
exports.getHorizontalBorderWidth = getHorizontalBorderWidth;
function getVerticalBorderWidth(root) {
    var element = elements.getPopoverElement(root);
    var button = elements.getButtonElement(root);
    var size = 0;
    if (element) {
        var elementStyle = window.getComputedStyle(element);
        size += getNumberValue(elementStyle.borderTopWidth);
        size += getNumberValue(elementStyle.borderBottomWidth);
    }
    if (button) {
        var buttonStyle = window.getComputedStyle(button);
        size += getNumberValue(buttonStyle.borderTopWidth);
        size += getNumberValue(buttonStyle.borderBottomWidth);
    }
    return size;
}
exports.getVerticalBorderWidth = getVerticalBorderWidth;
var canvas;
function getTextWidth(text, font) {
    if (!canvas) {
        canvas = document.createElement('canvas');
    }
    var context = canvas.getContext('2d');
    if (!context) {
        return 0;
    }
    if (font) {
        context.font = font;
    }
    var metrics = context.measureText(text);
    return metrics.width;
}
exports.getTextWidth = getTextWidth;
function getMinWidth(root, options) {
    var icon = elements.getIconElement(root);
    var iconWidth = 0;
    if (icon) {
        var iconStyles = window.getComputedStyle(icon);
        iconWidth +=
            getNumberValue(iconStyles.marginLeft) +
                getNumberValue(iconStyles.marginRight) +
                getNumberValue(iconStyles.width);
    }
    var input = elements.getInputElement(root);
    var inputWidth = 0;
    if (input) {
        var inputStyles = window.getComputedStyle(input);
        var textWidth = getTextWidth(options.text, inputStyles.font);
        inputWidth +=
            getNumberValue(inputStyles.paddingLeft) +
                getNumberValue(inputStyles.paddingRight) +
                textWidth;
    }
    var clearButton = elements.getClearButtonElement(root);
    var clearButtonWidth = 0;
    if (clearButton) {
        var clearButtonStyles = window.getComputedStyle(clearButton);
        clearButtonWidth =
            getNumberValue(clearButtonStyles.width) +
                getNumberValue(clearButtonStyles.marginLeft) +
                getNumberValue(clearButtonStyles.marginRight);
    }
    return Math.floor(
    // --
    inputWidth +
        // --
        iconWidth +
        // --
        clearButtonWidth +
        // --
        getHorizontalBorderWidth(root));
}
exports.getMinWidth = getMinWidth;
function getMinHeight(root) {
    var input = elements.getInputElement(root);
    var icon = elements.getIconElement(root);
    if (!input || !icon) {
        return 0;
    }
    var inputStyles = window.getComputedStyle(input);
    var iconStyles = window.getComputedStyle(icon);
    var inputHeight = getNumberValue(inputStyles.height);
    var iconHeight = getNumberValue(iconStyles.height);
    var paddings = 0;
    var height = 0;
    if (iconHeight > inputHeight) {
        height = iconHeight;
        paddings =
            getNumberValue(inputStyles.paddingTop) +
                getNumberValue(inputStyles.paddingBottom);
    }
    else {
        height = inputHeight;
    }
    return Math.floor(
    // --
    height +
        // --
        paddings +
        // --
        getVerticalBorderWidth(root));
}
exports.getMinHeight = getMinHeight;
//# sourceMappingURL=measure.js.map